import React, { useState } from 'react'
import ModalInc from '../../../../../shared-ui/ModalInc'
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Grid from "@material-ui/core/Grid";
import AlertDialog from '../../../../../components/AlertDialog/index.es6';
import { CircularProgress } from '@material-ui/core';
import { ClaimActionEnum } from '../../../ClaimDashboard/enum';
import { getUserFullname } from '../../../../../lib/access.es6';

const WaitingPeriodApprovalReason = (props) => {
  const [notes, setNotes] = useState('');
  const [description, setDescription] = useState('');

  const handleChange = (event) => {
    const { name, value } = event.target

    if (name === 'notes') {
      setNotes(value)
    } else if (name === 'description') {
      setDescription(value)
    }
  }

  const reset = () => {
    setNotes('');
    setDescription('');
  }

  const handleClaimNotes = () => {
    const payload = {
      text: notes,
      description: description,
      claim_guid: props.claimguid,
      created_by: getUserFullname()
    };
    props.handleClaimNotes(payload);

    // Approval action
    props.submitClaimAction({
      claim_action: ClaimActionEnum.approve,
      claim_guid: props.claimguid,
    });

    reset();
    if (props.toggleWaitingPeriodApprovedDialog) props.toggleWaitingPeriodApprovedDialog();
  }
  const handleNoteCreatedSuccessfully = () => {
    props.resetCreateNotesSuccessAlert();
    props.toggleClaimNotesDialog();  }
  const handleNoteCreateError = () => {
    props.resetCreateNotesErrorAlert();
  }
  return (
    <>
      <AlertDialog
        custom
        show={props.showCreateNoteProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2> Creating Claim Note...</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={props.showCreateNotesSuccessAlert}
        size="sm"
        title={'Claim note created'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handleNoteCreatedSuccessfully() }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={true}
        cancelBtnText={'cancel'}
        confirmBtnCssClass
      >

      </AlertDialog>

      <AlertDialog
        show={props.showCreateNotesErrorAlert}
        danger
        title={'Error creating claim note'}
        onConfirm={() => handleNoteCreateError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >

        {props.CreateNotesError ? props.CreateNotesError.message : ''}
      </AlertDialog>
      <ModalInc
        modalTitle="Add Reason "
        subTitle="Fill the below field to add reason on why you  approving this claim benefit from waiting period"
        open={props.openClaimWaitingPeriodDialog}
        onClose={props.toggleWaitingPeriodApprovedDialog}
        fullWidth
      >
        <ValidatorForm onSubmit={() => handleClaimNotes()} >

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <TextValidator
                name='description'
                id="description"
                label="Description"
                value={description}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                validators={['required']}
                errorMessages={['Please enter a description']}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextValidator
                name='notes'
                id="notes"
                label="Add Reasons"
                value={notes}
                onChange={handleChange}
                multiline
                rows={5}
                maxRows={4}
                fullWidth
                variant="outlined"
                validators={['required']}
                errorMessages={['Please enter claim Notes']}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} >
            <Grid item xs={12} sm={6} md={6}>

            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={8} md={8}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    type='submit'
                    style={{ marginTop: "20px", float: "right" }}
                  >
                    Approve Claim
                  </ButtonInc>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{ marginTop: "20px" }}
                    onClick={() => props.toggleWaitingPeriodApprovedDialog(false)}
                  >
                    Cancel
                  </ButtonInc>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </ValidatorForm>

      </ModalInc>
    </>
  )
}

export default WaitingPeriodApprovalReason